<div>
  @if (loadedDocuments?.length) {
    <div class="page">
      <div class="header">
        <div class="title">Documents</div>
      </div>
      <div class="doc-grid">
        @for (document of loadedDocuments; track document) {
          <div class="doc">
            <div class="doc-header">
              <span class="icon-pdf"></span>
              <div class="title">
                <div class="name">
                  {{ document.title }}
                </div>
                <div class="doc-type">
                  {{ document.subTitle }}
                </div>
              </div>
            </div>
            <div class="date">Created on {{ document.documentDate | date: 'MM/dd/yyyy' }}</div>
            @if (cancelDate && document.isPoi && document.poiIndex === 0) {
              <div class="doc-header">
                <div class="canceldate-label">Effective Dates</div>
                <div class="pilet">
                  <div class="pilet-text">Updated</div>
                </div>
              </div>
            }
            @if (cancelDate && document.isPoi && document.poiIndex === 0) {
              <div class="canceldate-value">
                {{ startDate | date: 'MM/dd/yyyy' }} -
                {{ cancelDate | date: 'MM/dd/yyyy' }}
              </div>
            }
            <div class="doc-footer">
              <div class="cta">
                @if (document.title === 'Proof of Insurance Card') {
                  <a
                    data-cy="get-pdf-documents-link"
                    (click)="checkCancelDateAndOpenDocument(document)"
                  >
                    <span>Open PDF Document</span>
                    <span class="icon-new-page"></span>
                  </a>
                } @else {
                  <a data-cy="get-pdf-documents-link" (click)="viewDocument(document)">
                    <span>Open PDF Document</span>
                    <span class="icon-new-page"></span>
                  </a>
                }
              </div>
            </div>
          </div>
        }
      </div>
      @if (documents.length > loadedDocuments.length || showAll) {
        <button class="show-all" (click)="toggleShowAll()">
          <div class="text">{{ showAll ? 'Show less documents' : 'Show all documents' }}</div>
          <span class="icon-chevron-right-thick" [class.icon-chevron-down-thick]="showAll"></span>
        </button>
      }
    </div>
  }
</div>

<ds-modal [id]="hasEffectiveDatesChangedModalId" [closeOthers]="true" maxWidth="800">
  <div>
    <h3 class="modal-header">Effective dates</h3>
    <div class="modal-text">
      <div>
        The policy effective dates have changed, but the dates in your documents will stay the same.
      </div>
      <div>Refer to the dates in the coverage details for the most accurate info.</div>
    </div>
    <button ds-button (click)="viewPOIDocument()" class="gotIt-btn">Got it</button>
  </div>
</ds-modal>
